import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { ACCOUNT_DISABLED_MESSAGE } from './LawAppBar';
import SubscriptionRequiredContent from './SubscriptionRequiredContent';

/**
 * Modal shown when a user without an active subscription attempts a gated action
 * (create case, upload documents).
 */
export default function SubscriptionRequiredDialog({ open, onClose }) {
    const navigate = useNavigate();
    const { user } = useAuth();
    const accountDisabled = user?.accountDisabled === true;

    function handleChoosePlan() {
        onClose();
        navigate('/account');
    }

    function handleContact() {
        onClose();
        navigate('/contact');
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="subscription-required-title"
            aria-describedby="subscription-required-description"
        >
            {accountDisabled ? (
                <>
                    <DialogTitle
                        id="subscription-required-title"
                        sx={{
                            color: 'var(--text-primary)',
                            fontWeight: 600,
                            fontSize: '1.35rem',
                            padding: '28px 28px 8px',
                        }}
                    >
                        Account Disabled
                    </DialogTitle>
                    <DialogContent sx={{ padding: '8px 28px 8px' }}>
                        <Typography
                            id="subscription-required-description"
                            sx={{ color: 'var(--text-secondary)', fontSize: '1rem', lineHeight: 1.6 }}
                        >
                            {ACCOUNT_DISABLED_MESSAGE} at /contact.
                        </Typography>
                    </DialogContent>
                    <DialogActions
                        sx={{
                            padding: '20px 28px 28px',
                            gap: 1.5,
                            justifyContent: 'flex-end',
                        }}
                    >
                        <Button onClick={onClose} sx={{ textTransform: 'none' }}>
                            Cancel
                        </Button>
                        <Button
                            onClick={handleContact}
                            autoFocus
                            disableElevation
                            sx={{
                                background: 'var(--button-gradient)',
                                color: '#fff',
                                fontWeight: 600,
                                textTransform: 'none',
                            }}
                        >
                            Contact Us
                        </Button>
                    </DialogActions>
                </>
            ) : (
                <SubscriptionRequiredContent
                    variant="dialog"
                    onChoosePlan={handleChoosePlan}
                    onCancel={onClose}
                    showCancel
                />
            )}
        </Dialog>
    );
}
